import { toast } from "react-toastify";
import { Constants } from "../config/constants";
import { getUserInfo, getlocalStorageOrDefault } from "./storage";
import { millisecondsToMinutes } from "date-fns";
import jwtDecode from 'jwt-decode';
import { getADFSLogoutUrl, getADFSTokenUrl } from "./authApi";
// import { updateLoginLogs } from "../api/admin";

// this return the expiration time "expireTime" minutes after current time
export const getExpirationTime = (expireTime = 60) => {
  const currDateTime = new Date();
  let expirationDateTime = new Date(currDateTime);
  expirationDateTime.setMinutes(currDateTime.getMinutes() + expireTime);

  return expirationDateTime;
};

export const getAuthUser = () => {
  const authUserKey = `LastAuthUser`;
  return getlocalStorageOrDefault(authUserKey, null);
};

export const getIdToken = () => {
  if (isTokenValid()) {
    const idTokenKey = `idToken`;
    return getlocalStorageOrDefault(idTokenKey, null);
  }
  return null;
};

export const getToken = () => {
  const idTokenKey = `idToken`;
  return getlocalStorageOrDefault(idTokenKey, null);
};

export const retrieveToken = (code) => {
  return new Promise((resolve, reject) => {
    getADFSTokenUrl(code).then(
      (data) => {
        if (data && data?.IdToken) {
          const token = data.IdToken;
          const refreshToken = data.RefreshToken;
          const accessToken = data.AccessToken;
          const decoded = jwtDecode(token);
          const username = decoded["cognito:username"];
          localStorage.setItem("LastAuthUser",username);
          localStorage.setItem("idToken",token);
          localStorage.setItem("RefreshToken",refreshToken);
          localStorage.setItem("AccessToken",accessToken);
          localStorage.setItem("userLoggedIn", true);
          localStorage.setItem("token_expiry", getExpirationTime());
          resolve(true);
          return true;
        } else {
          toast.error("Didn't get token, Try to login again");
          // localStorage.clear();
          // getADFSLogoutUrl();
          window.location.href = "/login";
          resolve(false);
          return false;
        }
      },
      (err) => {
        reject(err);
        toast.error("Something went wrong, Try to login again");
        // localStorage.clear();
        // getADFSLogoutUrl();
        window.location.href = "/login";

        return false;
      }
    );
  });
};

// this is used to if user token is valid or expired
export const isTokenValid = () => {
  const tokenExpiry = new Date(localStorage.getItem("token_expiry")).getTime();
  const today = new Date().getTime();

  const diff = tokenExpiry - today;
  const diffInMins = millisecondsToMinutes(diff);

  const alreadyRefreshed = localStorage.getItem("refresh_call");
  if (!alreadyRefreshed && diffInMins < 10 && diffInMins > 0) {
    localStorage.setItem("refresh_call", true);
    retrieveToken()
      .then(() => {
        localStorage.removeItem("refresh_call");
      })
      .catch(() => {
        localStorage.removeItem("refresh_call");
      });
    return true;
  }

  return diffInMins > 0;
};

export const checkIfAdmin = (userInfo) => {
  return userInfo?.roles?.includes("admin");
};

export const logOut = () => {
  localStorage.clear();
  getADFSLogoutUrl();
};
